import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  EmailConnectionsStatus,
  EmailProvider,
  useEmailConnectionService,
} from '../services/email-connection.service';

export const emailConnectionKeys = {
  all: ['email-connections'] as const,
  status: () => [...emailConnectionKeys.all, 'status'] as const,
};

export const useEmailConnections = (options?: { enabled?: boolean }) => {
  const service = useEmailConnectionService();
  const queryClient = useQueryClient();

  const query = useQuery<EmailConnectionsStatus, Error>({
    queryKey: emailConnectionKeys.status(),
    queryFn: service.getStatus,
    staleTime: 30 * 1000,
    ...options,
  });

  // Starting the flow returns a provider consent URL; we navigate the whole
  // window there so the provider can redirect back to /settings on completion.
  const startMutation = useMutation({
    mutationFn: (provider: EmailProvider) => service.start(provider),
    onSuccess: ({ authorization_url }) => {
      window.location.assign(authorization_url);
    },
  });

  const disconnectMutation = useMutation({
    mutationFn: (provider: EmailProvider) => service.disconnect(provider),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: emailConnectionKeys.status() });
    },
  });

  return { ...query, startMutation, disconnectMutation };
};
